import storage from 'storejs';
import serviceAPI from '../../api/serviceAPI';
import { getUrlParam } from '../../utils/index';

export default {
  namespaced: true,
  state: {
    userInfo: {}, // 用户信息
    rows: [], // 记忆选择
  },
  getters: {
    // 用户信息
    userInfo(state) {
      return state.userInfo;
    },
    getRows: state => state.rows,
  },
  mutations: {
    // 设置登录信息
    _setUserInfo(state, userInfo) {
      console.log('userInfo', userInfo);
      state.userInfo = {};
      state.userInfo.userId = userInfo.data.userId;
      state.userInfo.type = userInfo.data.type;
      state.userInfo.userType = userInfo.data.userType;
      state.userInfo.companyCode = userInfo.data.companyCode;
      state.userInfo.areaCode = userInfo.data.productCode;
      state.userInfo.userIntegral = userInfo.data.userIntegral;
      state.userInfo.userMobile = userInfo.data.userMobile;
      state.userInfo.userName = userInfo.data.userName;
      state.userInfo.nickName = userInfo.data.nickName;
      state.userInfo.logo = userInfo.data.logo;
    },
    insertRow: (state, row) => {
      const index = state.rows.findIndex(item => {
        return item.lecturerCode === row.lecturerCode;
      });
      if (index === -1) {
        state.rows.push(row);
      }
    },
    deleteRow: (state, { lecturerCode }) => {
      const index = state.rows.findIndex(item => {
        return item.lecturerCode === lecturerCode;
      });
      if (index !== -1) {
        state.rows.splice(index, 1);
      }
    },
    insertAllRow: (state, rows) => {
      rows.forEach(item => {
        const index = state.rows.findIndex(ele => {
          return ele.lecturerCode === item.lecturerCode;
        });
        if (index === -1) {
          state.rows.push(item);
        }
      });
    },
    deleteAllRow: (state, rows) => {
      rows.forEach(item => {
        const index = state.rows.findIndex(ele => {
          return ele.lecturerCode === item.lecturerCode;
        });
        if (index !== -1) {
          state.rows.splice(index, 1);
        }
      });
    },
    setRows: (state, rows) => {
      state.rows = JSON.parse(JSON.stringify(rows));
    },
  },
  actions: {
    // 保存用户信息
    save({ commit }, userInfo) {
      console.log('父类调用');
      //  读取storage
      const myUserInfo = {};
      let storageMy = storage(myUserInfo.companyCode);
      if (!storageMy) {
        storageMy = {};
      }
      myUserInfo.userId = userInfo.data.userId;
      myUserInfo.type = userInfo.data.type;
      myUserInfo.userType = userInfo.data.userType;
      myUserInfo.companyCode = userInfo.data.companyCode;
      myUserInfo.areaCode = userInfo.data.productCode;
      myUserInfo.userIntegral = userInfo.data.userIntegral;
      myUserInfo.mobile = userInfo.data.userMobile;
      myUserInfo.userName = userInfo.data.userName;
      myUserInfo.nickName = userInfo.data.nickName;
      myUserInfo.logo = userInfo.data.logo;
      myUserInfo.token = getUrlParam('token');
      storageMy.userInfo = myUserInfo
      storage({ [myUserInfo.companyCode]: storageMy });
      commit('_setUserInfo', userInfo);
    },
    // 用户授权
    /**
     * @param {Object} params-请求参数
     */
    async authorize({ dispatch }, params) {
      try {
        const userInfo = await serviceAPI.login(params);
        // 获取公司logo
        const logoDetails = await serviceAPI.getCompanyLogo({companyCode: userInfo.data.companyCode});
        userInfo.data.logo = logoDetails.data.logo;
        // 保存登录信息
        dispatch('save', userInfo);
      } catch (error) {
        console.log('登录失败', error);
        throw error;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js